import { WithDrawInfo } from "@/components/features/transaction/transactionSlice";
import http from "../utils/axiosInstance";

class withdrawData {
  requestWithdraw(data: WithDrawInfo) {
    return http.post(`/transaction/withdraw`, data);
  }
  sendTraningFees() {
    return http.patch(`/training`);
  }
}

const userWithdraw = new withdrawData();
export default userWithdraw;
